<template>
  <div class="pl-4">
    <div class="text-white pt-3">
      <a @click="routeToGrooveDigitalAcademy" class="cursor-pointer">{{
        capitalizeFirstLetter(
          $t('frontend_sites_side_bar_groovedigital_academy')
        )
      }}</a>
    </div>
    <div class="text-white pt-3">
      <a @click="routeToGrooveTutorials" class="cursor-pointer">{{
        capitalizeFirstLetter($t('frontend_sites_side_bar_tutorials'))
      }}</a>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentApp: 'groovepages',
    };
  },
  created() {
    // Finding app from the url
    if (window.location.href.indexOf('/groovesell/') > -1) {
      this.currentApp = 'groovesell';
    } else if (window.location.href.indexOf('/groovemail/') > -1) {
      this.currentApp = 'groovemail';
    } else if (window.location.href.indexOf('/groovevideo/') > -1) {
      this.currentApp = 'groovevideo';
    } else if (window.location.href.indexOf('/groovemember/') > -1) {
      this.currentApp = 'groovemember';
    }
  },
  methods: {
    capitalizeFirstLetter(str) {
      return str
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    },

    routeToGrooveDigitalAcademy() {
      window.open(this.$t('official_link_academy'), '_blank');
    },

    routeToGrooveTutorials() {
      window.open(this.$t('official_link_tutorials'), '_blank');
    },
  },
};
</script>
